import * as angular from "angular";

export class ServiceAreaRequests {

  /* @ngInject */
  constructor(private $serviceArea, private ServiceAreasAPI) {
  }

  // ******************************
  // External methods
  // ******************************

  getAreasByIds(ids) {
    const api = this.ServiceAreasAPI.actions.getAreasByIds;
    return this.$$call(api, {}, {ids: ids}, {});
  }

  searchAreasByAddressGeoLocation(lat, lng) {
    const api = this.ServiceAreasAPI.actions.searchAreasByAddressGeoLocation;
    return this.$$call(api, {lat: lat, lng: lng}, {}, {});
  }

  createNewServiceArea(serviceArea) {
    const api = this.ServiceAreasAPI.actions.create;
    return this.$$call(api, {}, serviceArea, {});
  }

  deleteOne(areaId) {
    const api = this.ServiceAreasAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: areaId});
  }

  getAreaNameMap() {
    const api = this.ServiceAreasAPI.actions.getAreaNameMap;
    return this.$$call(api, {}, {}, {});
  }

  getAreasByBranches(branchIds, serviceTypes?) {
    const api = this.ServiceAreasAPI.actions.getAreas;
    return this.$$call(api, {branchIds: branchIds, serviceTypes: serviceTypes}, {}, {});
  }

  updateAreasBranches(updatedAreas) {
    const api = this.ServiceAreasAPI.actions.branches;
    return this.$$call(api, {}, updatedAreas, {});
  }

  getAll(queryParams) {
    const api = this.ServiceAreasAPI.actions.getAll;
    return this.$$call(api, queryParams, {}, {});
  }

  getGeoJson(queryParams) {
    const api = this.ServiceAreasAPI.actions.getGeoJson;
    return this.$$call(api, queryParams, {}, {});
  }

  exportGeoJson(queryParams) {
    const api = this.ServiceAreasAPI.actions.exportGeoJson;
    return this.$$call(api, queryParams, {}, {});
  }

  exportKml(queryParams) {
    const api = this.ServiceAreasAPI.actions.exportKml;
    return this.$$call(api, queryParams, {}, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(apiCall, params, data, options) {
    return this.$serviceArea().$call(apiCall, params, data, options, true);
  }

}

angular
  .module('bringoz.admin.service-areas')
  .service('serviceAreaRequests', ServiceAreaRequests);
